'use strict';

angular.module('TurneroApp').service('calendarioService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Calendario/:id', { id: '@Id_Calendario' }, {
        Get_Calendario: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Calendario/Get_Calendario'
        },
        Get_Calendario_Telefonico:{
        	method: 'GET',
        	url: portal.getUrlServer() + 'api/Calendario/Get_Calendario_Telefonico'
        },
        Get_Calendario_Online: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Calendario/Get_Calendario_Online'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/general/calendario-service.js